var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('HomeHeader'),_vm._v(" "),_c('HomeSwiper',{attrs:{"swiper":_vm.swiper}}),_vm._v(" "),_c('HomeCategory',{attrs:{"iconList":_vm.iconList}}),_vm._v(" "),_c('HomeSales',{attrs:{"homeHotSaleList":_vm.homeHotSaleList}}),_vm._v(" "),_c('HomeWeek',{attrs:{"weekendList":_vm.weekendList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b8e255a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/home.vue
// module id = null
// module chunks = 